import React, { Component } from 'react';
import Pagination from '../../helpers/Pagination';
const $= window.$;


class ActiveObservers extends Component {
	constructor(props) {
		super(props);
		
		 this.state={
			pageOfItems:[],
			activeob:props.activeob
        };
		this.onChangePage = this.onChangePage.bind(this);
	}

	componentWillReceiveProps(nextProps) {
		// alert('im in');
         if(nextProps.activeob!=undefined){
            this.setState({
            	activeob:nextProps.activeob,
                pageOfItems:nextProps.activeob,
            })
         }
	}

	onChangePage(pageOfItems) {
        // update state with new page of items
        this.setState({ pageOfItems: pageOfItems });
    }

		render() {

        	//const {activeob} = this.props;
        	//alert(JSON.stringify(activeob));
			 let rows = this.state.pageOfItems.map((active,i) => {
			 	var value = active.sno;
                return (
		                   <tr key={`actobserver_${i}`}>
			                   	<td>{value}</td>
				                <td>{active.name}</td>
				                <td>{active.relationship}</td>
				                <td>{active.email}</td>
				                <td>{active.phno}</td>
		                   </tr> 
		                )
		       });

			 (rows.length == 0) ? rows = <tr align="center"><td colSpan="5">You have no active Observers.</td></tr> : rows = rows

			return (
				<div>
					<table border="0" width="100%" className="myjourney-table">
	                    <thead>
	                        <tr>
	                            <th>Sno</th>
	                            <th>Observer Name</th>
	                            <th>Relationship</th>
	                            <th>Email ID</th>
	                            <th>Contact No</th>
	                        </tr>
	                    </thead>

					  	<tbody>
					  		{rows}
					  	</tbody>
					</table>
					<div className="pull-right">
					<Pagination items={this.state.activeob} onChangePage={e=>this.onChangePage(e)} />
					</div>
				</div>
			);
		}
}

export default ActiveObservers;



// WEBPACK FOOTER //
// ./src/personal_interactions/observer/ActiveObservers.js